var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _circle3, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 52,
    r: 36,
    fill: "#C75E5A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 52,
    r: 32,
    fill: "#FAC1B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 52L50 20L77.7 36Z",
    fill: "#F9907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52L77.7 68L77.7 36Z",
    fill: "#C75E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52L50 84L77.7 68Z",
    fill: "#F9907B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52L50 84L22.3 68Z",
    fill: "#C75E5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52L22.3 36L22.3 68Z",
    fill: "#F9907B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52L50 20L22.3 36Z",
    fill: "#C75E5A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 52,
    r: 5,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 6L44 16L56 16Z",
    fill: "#C75E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinWheel);
export default __webpack_public_path__ + "static/media/SpinWheel.1105056105c156b3f1e473680bab7342.svg";
export { ForwardRef as ReactComponent };